import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminInventory() {
  const [products, setProducts] = useState([]);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get("/admin/inventory").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const toggle = async (productId, size) => {
    setBusy(`${productId}|${size}`);
    try {
      const { data } = await api.post("/admin/inventory/toggle", { product_id: productId, size });
      setProducts((prev) => prev.map((p) => {
        if (p.id !== productId) return p;
        const waiting = { ...p.waiting };
        if (data.notified > 0) waiting[size] = 0;
        return { ...p, sold_out_sizes: data.sold_out_sizes, waiting };
      }));
      if (data.notified > 0) toast.success(`Back in stock — ${data.notified} shopper${data.notified > 1 ? "s" : ""} notified by email.`);
    } catch {
      toast.error("Could not update inventory.");
    }
    setBusy(null);
  };

  if (!products.length) return null;

  return (
    <div className="mt-20" data-testid="admin-inventory">
      <div className="flex items-baseline justify-between mb-2">
        <h2 className="font-anton uppercase text-3xl">Inventory</h2>
        <span className="font-mono text-[11px] uppercase tracking-wider text-graphite">Admin only</span>
      </div>
      <p className="text-graphite text-sm mb-8">Tap a size to mark it sold out / back in stock. Restocking automatically emails everyone waiting.</p>
      <div className="space-y-3">
        {products.map((p) => (
          <div key={p.id} className="border border-border p-5 flex flex-wrap items-center gap-4" data-testid={`inventory-row-${p.id}`}>
            <div className="min-w-[220px]">
              <p className="font-medium text-sm">{p.name}</p>
              <p className="font-mono text-[10px] uppercase tracking-wider text-graphite mt-1">{p.collection}</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {p.sizes.map((s) => {
                const out = p.sold_out_sizes.includes(s);
                const waiting = p.waiting?.[s] || 0;
                return (
                  <button key={s} onClick={() => toggle(p.id, s)} disabled={busy === `${p.id}|${s}`}
                    data-testid={`inv-${p.id}-${s}`}
                    className={`relative font-mono text-xs min-w-[48px] h-10 px-2 border transition-colors disabled:opacity-50 ${
                      out ? "border-pulse/60 text-chalk/40 line-through decoration-pulse decoration-2" : "border-border text-chalk/80 hover:border-chalk"
                    }`}>
                    {s}
                    {waiting > 0 && (
                      <span className="absolute -top-2 -right-2 bg-signal text-ink font-mono text-[9px] px-1.5 py-0.5" data-testid={`inv-waiting-${p.id}-${s}`}>
                        {waiting}
                      </span>
                    )}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
